import React from 'react';
import OverviewForm from '../OverviewForm';
import MicrosoftTeamsChannelForm from '../MicrosoftTeamsChannelForm';
import ApprovalOptions from './ApprovalOptions';
import BasicInformation from './BasicInformation';
import Billing from './Billing';
import CloudFolder from './CloudFolder';
import InvoiceDetails from './InvoiceDetails';
import QuickBooks from './QuickBooks';
import Settings from './Settings';
import Slack from './Slack';
import TimeTrackingRules from './TimeTrackingRules';

// Overview is a set of independent forms, one per route, each saving on its own. They share the overview
// PATCH and the same seeded values, so what a member edits here is the section in front of them and nothing
// else. The integration sections are listed only where that integration is set up — SettingsTab answers that,
// since the nav has to know before the form loads.
export default function getOverviewSections(
  project,
  onSaved,
  { isSlackConnected, isMicrosoftTeamsConnected, isQuickBooksEnabled } = {},
) {
  const section = (key, name, fields, options) => ({
    key,
    name,
    component: <OverviewForm project={project} onSaved={onSaved} section={key} fields={fields} {...options} />,
  });

  return [
    section('basic-information', 'Basic Information', BasicInformation, {
      canDelete: true,
    }),
    section('settings', 'Settings', Settings),
    section('time-tracking-rules', 'Time Tracking Rules', TimeTrackingRules),
    section('approval-options', 'Approval Options', ApprovalOptions),
    section('billing', 'Billing', Billing),
    // Read from the saved project, not the form, so switching to an internal client keeps the section until saved.
    ...(project.client && !project.client.isInternal
      ? [section('invoice-details', 'Invoice Details', InvoiceDetails)]
      : []),
    section('cloud-folder', 'Cloud Folder', CloudFolder),
    ...(isSlackConnected ? [section('slack', 'Slack', Slack)] : []),
    ...(isMicrosoftTeamsConnected
      ? [
          {
            key: 'microsoft-teams',
            name: 'Microsoft Teams',
            component: <MicrosoftTeamsChannelForm project={project} />,
          },
        ]
      : []),
    ...(isQuickBooksEnabled ? [section('quickbooks', 'QuickBooks', QuickBooks)] : []),
  ];
}
